<sd-input label="время доставки" [comment]="selectedGroup().description">
  <input
    #inputRef
    type="text"
    [formControl]="control"
    type="text"
    mask="00:00"
    [validation]="false"
    [dropSpecialCharacters]="false"
    (keydown.enter)="inputRef.blur()"
  />
</sd-input>
